import { CSSProperties } from 'react';

import { ChartV2ThemeVars } from '../types/chart-v2.types';

const THEME_KEY_TO_CSS_VAR: Record<string, string> = {
  background: '--chartv2-background',
  foreground: '--chartv2-foreground',
  gridLine: '--chartv2-grid-line',
  axisLine: '--chartv2-axis-line',
  axisLabel: '--chartv2-axis-label',
  tooltipBackground: '--chartv2-tooltip-background',
  tooltipForeground: '--chartv2-tooltip-foreground',
  crosshair: '--chartv2-crosshair',
  seriesDefault: '--chartv2-series-default',
  primary: '--chartv2-primary',
  up: '--chartv2-up',
  down: '--chartv2-down',
  chipSurface: '--chartv2-chip-surface',
  chipHover: '--chartv2-chip-hover',
  chipActive: '--chartv2-chip-active',
  selectorBackground: '--chartv2-selector-background',
  surfaceRaised: '--chartv2-surface-raised',
  focus: '--chartv2-focus',
};

export const themeToCssVars = (theme?: ChartV2ThemeVars): CSSProperties => {
  const style: CSSProperties & Record<string, string> = {};

  if (!theme) {
    return style;
  }

  Object.entries(theme).forEach(([key, value]) => {
    if (value == null) {
      return;
    }

    const cssVar = THEME_KEY_TO_CSS_VAR[key] ?? key;
    style[cssVar] = value;
  });
  return style;
};
